import { Component, Input } from '@angular/core';
import { ShellUpdateService, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';

////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     09/11/2017
// Description: Component to display a header along the top of each component that uses it
////-------------------------------------------------------------------------------------------

@Component({
  selector: 'app-header',
  templateUrl: './portal-header.component.html',
  styleUrls: ['./portal-header.component.css']
})
export class PortalHeaderComponent {
  @Input() public name: string;           // The application name to appear in the header
  @Input() public title: string;          // The page title to appear in the header
  @Input() public displayMenu: boolean;   // Display or Hide the burgermenu on the side of the screen.
  @Input() public displayBack: boolean;
  @Input() public displayHeader: boolean;

  constructor(private shellUpdateService: ShellUpdateService, public appConfigService: AppConfigService) { }

  // Sends a message to any listening component to open the side menu
  openSideNavigation() {
    const shellAction: ShellActionMessage = new ShellActionMessage(true, null, null, null, true);
    this.shellUpdateService.sendShellUpdateActionMessage(shellAction);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/portal-header/portal-header.component.ts